import axios from '@/axios.js'

export default {
    getMaps: async (resortUuid) => {
        try {
            const response = await axios.editorapi.get(`v4/resorts/${resortUuid}/maps`)
            return response.data.object
        } catch (error) {
            throw new Error(error)
        }
    },
    getMapTypes: async (resortUuid) => {
        try {
            const response = await axios.editorapi.get(`v4/resorts/${resortUuid}/maps/types`)
            return response.data.object
        } catch (error) {
            throw new Error(error)
        }
    },
    createMap: async (resortUuid, payload) => {
        try {
            const response = await axios.editorapi.post(`v4/resorts/${resortUuid}/maps`, payload)
            return response.data
        } catch (error) {
            throw new Error(error)
        }
    },
    saveMap: async (resortUuid, mapUuid, payload) => {
        try {
            const response = await axios.editorapi.patch(`v4/resorts/${resortUuid}/maps/${mapUuid}`, payload)
            return response.data
        } catch (error) {
            throw new Error(error)
        }
    },
    deleteMap: async (resortUuid, mapUuid) => {
        try {
            const response = await axios.editorapi.delete(`v4/resorts/${resortUuid}/maps/${mapUuid}`)
            return response.data
        } catch (error) {
            throw new Error(error)
        }
    }
}